import Elimination from './elimination';

export * from './elimination';
export default Elimination;
